<template>
    <v-card :loading="loading" mx-4>
        <v-skeleton-loader
            v-if="loading"
            type="card"
        ></v-skeleton-loader>
        <v-tabs
            v-else
            v-model="tab"
            background-color="primary"
            dark
        >
            <v-tab key="general">
                Informatii generale
            </v-tab>
            <v-tab v-if="id" key="file">
                Fisa Furnizorului
            </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
            <v-tab-item key="general">
                <v-card class="px-4 py-4" flat>
                    <v-text-field
                        v-model="form.name"
                        v-validate="'required'"
                        :error-messages="errorMessages('name')"
                        :class="{ 'error--text': hasErrors('name') }"
                        class="primary--text"
                        name="name"
                        label="Denumire"
                        data-vv-as="Denumire"
                        data-vv-name="name"
                        counter="255"
                    />
                    <v-text-field
                        v-model="form.vat_no"
                        v-validate="'required'"
                        :error-messages="errorMessages('vat_no')"
                        :class="{ 'error--text': hasErrors('vat_no') }"
                        class="primary--text"
                        name="vat_no"
                        label="CUI (Cod Unic de Identificare)"
                        data-vv-as="CUI (Cod Unic de Identificare)"
                        data-vv-name="vat_no"
                        counter="255"
                    />
                    <v-text-field
                        v-model="form.trn"
                        v-validate="'required'"
                        :error-messages="errorMessages('trn')"
                        :class="{ 'error--text': hasErrors('trn') }"
                        class="primary--text"
                        name="trn"
                        label="Numarul Registrul Comertului"
                        data-vv-as="Numarul Registrul Comertului"
                        data-vv-name="trn"
                        counter="255"
                    />
                    <v-text-field
                        v-model="form.data.bank"
                        :error-messages="errorMessages('bank')"
                        :class="{ 'error--text': hasErrors('bank') }"
                        class="primary--text"
                        name="bank"
                        label="Banca"
                        data-vv-as="Banca"
                        data-vv-name="bank"
                        counter="255"
                    />
                    <v-text-field
                        v-model="form.data.bank_account"
                        :error-messages="errorMessages('bank_account')"
                        :class="{ 'error--text': hasErrors('bank_account') }"
                        class="primary--text"
                        name="bank_account"
                        label="IBAN"
                        data-vv-as="IBAN"
                        data-vv-name="bank_account"
                        counter="255"
                    />
                    <v-divider
                        class="mx-4"
                        vertical
                    ></v-divider>
                    <v-subheader>
                        Sediu social
                    </v-subheader>

                    <v-select
                        v-model="form.county_id"
                        v-validate="'required'"
                        :items="Static.counties"
                        :error-messages="errorMessages('county_id')"
                        :class="{ 'error--text': hasErrors('county_id') }"
                        class="primary--text"
                        name="county_id"
                        label="Judet"
                        data-vv-as="Judet"
                        item-value="id"
                        item-text="name"
                        data-vv-name="county_id"
                    />

                    <v-text-field
                        v-model="form.city"
                        v-validate="'required'"
                        :error-messages="errorMessages('city')"
                        :class="{ 'error--text': hasErrors('city') }"
                        class="primary--text"
                        name="city"
                        label="Localitate"
                        data-vv-as="Localitate"
                        data-vv-name="city"
                        counter="255"
                    />
                    <v-text-field
                        v-model="form.address"
                        v-validate="'required'"
                        :error-messages="errorMessages('address')"
                        :class="{ 'error--text': hasErrors('address') }"
                        class="primary--text"
                        name="address"
                        label="Strada"
                        data-vv-as="Strada"
                        data-vv-name="address"
                        counter="255"
                    />

                    <v-divider
                        class="mx-4"
                        vertical
                    ></v-divider>
                    <v-subheader>
                        Alte informatii
                    </v-subheader>
                    <v-text-field
                        v-model="form.contact_person"
                        :error-messages="errorMessages('contact_person')"
                        :class="{ 'error--text': hasErrors('contact_person') }"
                        class="primary--text"
                        name="contact_person"
                        label="Persoana de contact"
                        data-vv-as="Persoana de contact"
                        data-vv-name="contact_person"
                        counter="255"
                    />
                    <v-text-field
                        v-model="form.phone"
                        :error-messages="errorMessages('phone')"
                        :class="{ 'error--text': hasErrors('phone') }"
                        class="primary--text"
                        name="phone"
                        label="Telefon"
                        data-vv-as="Telefon"
                        data-vv-name="phone"
                        counter="255"
                    />
                    <v-text-field
                        v-model="form.email"
                        v-validate="'email'"
                        :error-messages="errorMessages('email')"
                        :class="{ 'error--text': hasErrors('email') }"
                        class="primary--text"
                        name="email"
                        label="E-mail"
                        data-vv-as="E-mail"
                        data-vv-name="email"
                        counter="255"
                    />
                    <v-text-field
                        v-model="form.data.due_days"
                        v-validate="'numeric'"
                        :error-messages="errorMessages('due_days')"
                        :class="{ 'error--text': hasErrors('due_days') }"
                        class="primary--text"
                        name="due_days"
                        label="Zile scadenta"
                        data-vv-as="Zile scadenta"
                        data-vv-name="due_days"
                        counter="255"
                    />
                    <v-textarea
                        v-model="form.data.remarks"
                        :error-messages="errorMessages('remarks')"
                        :class="{ 'error--text': hasErrors('remarks') }"
                        class="primary--text"
                        name="remarks"
                        label="Observatii"
                        data-vv-as="Observatii"
                        data-vv-name="remarks"
                        counter="255"
                    />

                    <v-btn
                        :loading="form.busy"
                        :disabled="errors.any() || form.busy"
                        block
                        color="success"
                        @click="submit()"
                    >
                        Salveaza
                        <v-icon right>
                            save
                        </v-icon>
                    </v-btn>
                </v-card>
            </v-tab-item>

            <v-tab-item key="file">
                <v-card class="px-4 py-4" flat>
                    <expenses-component :id="id" :supplier="form"></expenses-component>
                </v-card>
            </v-tab-item>
        </v-tabs-items>
    </v-card>
</template>

<script>
    import validationError from "Mixins/validation-error";
    import {Form} from "vform";
    import ExpensesComponent from "./ExpensesComponent";

    export default {
        components: {
            ExpensesComponent
        },
        mixins: [validationError],
        props: {
            id: {
                type: [Number, String],
                required: false
            }
        },
        data: () => ({
            tab: 'general',
            loading: false,
            /* Always Declare Your Form Object */
            form: new Form({
                id: null,
                name: null,
                vat_no: null,
                trn: null,
                county_id: null,
                city: null,
                address: null,
                contact_person: null,
                phone: null,
                email: null,
                data: {
                    bank_account: null,
                    bank: null,

                    due_days: null,
                    remarks: null,
                },
                expenses: []
            }),
        }),
        async mounted() {
            if(this.id) {
                await this.loadResource()
            }
        },
        methods: {
            async loadResource() {
                let self = this;
                this.loading = true;

                let { data } = await this.$db.Supplier.find(this.id)
                self.form = new Form(data)
                this.loading = false
            },
            async submit() {
                let self = this;
                this.$validator.validateAll().then(result => {
                    if (result) {
                        // eslint-disable-next-line
                        self.createOrUpdate();
                    } else {
                        this.showError()
                    }
                });
            },
            async createOrUpdate() {
                let self = this;
                self.form.busy = true;

                var model = new this.$db.Supplier(self.form);
                if (this.id) {
                    model.id = this.id
                }

                model.save()
                    .then(response => {
                        self.$validator.reset();
                        this.showSuccess();
                        self.$nextTick(() => self.$router.push({name: "suppliers-index"}));
                    })
                    .catch(errors => {
                        self.form.errors.set(this.form.extractErrors(errors.response))
                        this.showError()
                    }).finally(() => {
                        self.form.busy = false;
                    });
            }
        }
    };
</script>
